<template>
  <div id="comment-container" class="comment">
    <f-comment-header />
    <f-comment-content />
    <f-comment-footer :proposalEncryptId="proposal_id" :isProposal="isProposal"/>
  </div>
</template>

<script>
  import FCommentHeader from './CommentHeader';
  import FCommentContent from './CommentContent';
  import FCommentFooter from './CommentFooter';

  export default {
    name: 'f-comment',
    components: {
      FCommentFooter,
      FCommentHeader,
      FCommentContent
    },
    props: {
      service: {
        type: String,
        default: "proposal",
      },
      isProposal: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      closeComment() {
        const contentArea = document.querySelector('.content-area');
        contentArea.classList.add("close");
      },
      openComment(proposal_id = null) {
        if(proposal_id) {
          this.proposal_id = proposal_id;
        }

        const contentArea = document.querySelector('.content-area');
        contentArea.classList.remove("close");
      },
      scrollToEnd: function() {
        const container = this.$el.querySelector("#comment-container .comment__content");
        container.scrollTop = container.scrollHeight;
      },
      scrollHeightContent() {
        const selector = {
          container: document.querySelector("#comment-container"),
          header: document.querySelector(".comment__header"),
          footer: document.querySelector(".comment__footer"),
          content: document.querySelector("#comment-container .comment__content")
        };

        const contentHeight = selector.container.offsetHeight
          - selector.header.offsetHeight
          - selector.footer.offsetHeight;

        selector.content.style.maxHeight = contentHeight + 'px';

        return selector.content.scrollTop = selector.content.scrollHeight;
      },
    },
    async mounted() {
      let targetId = this.$route.params.id;
      await this.$store.dispatch('frontend/user/getAllActiveUser', {
        service: this.service,
        targetId
      })
      this.$nuxt.$on('openComment', () => {
        this.scrollHeightContent();
        this.openComment();
      })
    },
    data: () => ({
      proposal_id: null
    })
  }
</script>
